<script>
    import { onMount, afterUpdate } from 'svelte';
    import { db, functions } from './stores.js';
    // import Host from './Host.svelte';
    import Camera from './Camera.svelte';
    import Screenshare from './Screenshare.svelte';
    import Scene from './Scene.svelte';
    import Chat from './Chat.svelte';
    import ConfirmYouTube from './ConfirmYouTube.svelte';

    export let event = {};
    let openTokCreds = {};
    let showPassword = false;
    let status = '';
    let copyStatus = '';
    let broadcastStatus = '';
    let session;
    const role = 'host';

    let localStream;

    let siteLine1 = "otech.";
    let siteLine2 = "events";
    // let sceneType = 'live'
    // let xOffset;
    const canvas = document.createElement('canvas');
    // let canvas;
    canvas.width = 1280;
    canvas.height = 720;
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    // xOffset = canvas.width;
    const ctx = canvas.getContext('2d');
    // let ctx;
    let canvasPublisher;
    let mediaContainer;

    let hostScreen;

    let hostVideo;

    let windowWidth;

    let mediaContainerWidth = 1280;

    let broadcast;

    let archive;

    let showDisplay = 'break'; 

    let isBroadcasting = false;

    const dateTimeOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    let gotHostCamera = false;
    let gotHostScreenshare = false;
    let gotGuestCamera = false;
    let gotGuestScreenshare = false;

    let hostConnection;
    let guestConnection;

    let hostMuted = false;
    let guestMuted = false;

    let showYouTubeConfirm = false;

    $: guestLink = `${window.location.href.toLowerCase()}?guest/${event.id}`;
    $: changexoffset = Math.abs(windowWidth-canvas.width)/2;
    $: eventDateTime = new Date(event.time);
    $: sceneType = 'Starting Soon.';
    // $: sceneInfo = {'line1':textLine1, 'line2':textLine2, 'type':sceneType};
    // $: longerText = textLine1.length > textLine2.length ? textLine1 : textLine2;
    // $: text = ctx.measureText(longerText);
    // $: xOffset = sceneType === 'live' ? canvas.width-text.width : canvas.width/2;
    // $: mediaContainerWidth = mediaContainer.offsetWidth

    onMount (async()=> {
       const res = await fetch(`https://us-central1-otech-events.cloudfunctions.net/dashboard?id=${event.id}`)
       openTokCreds = await res.json();
       console.log('openTokCreds: ', openTokCreds);
       console.log('event: ',event);
       // https://stackoverflow.com/questions/56970491/why-is-video-from-canvas-capturestream-empty-when-using-drawimage-with-mediareco
       //trying to get an image from an outside may not be set up for requests from localhost, 
       //so it will throw an error and stop streaming data to OT which causes an error
       //need a proxy server like cors-anywhere.herokuapp.com
       const img = new Image();
       img.crossOrigin = 'anonymous';
    //    img.src = `https://cors-anywhere.herokuapp.com/${event.groupPhotoLink}`;
       img.src = `https://us-central1-otech-events.cloudfunctions.net/proxy/${event.groupPhotoLink.replace('https://','')}`;
        img.onload = function() {
            console.log('image loaded: ',img);
            const w = img.width,
            h = img.height;
        }
       //set up canvas
       const interval = setInterval(() => {
        //    console.log('setInterval: ',canvas);
           ctx.fillStyle = 'white';
           ctx.fillRect(0, 0, canvas.width, canvas.height);

            if (sceneType === 'live' && showDisplay.includes('And')){
                ctx.font = '48px sans-serif';
                ctx.fillStyle = 'black';
                // Use the line with the most characters for the width
                let text = ctx.measureText(siteLine2);
                //console.log('text: ',text);
                ctx.textAlign = 'center';
                ctx.fillText(siteLine1, canvas.width-text.width, canvas.height/2-15,text.width);
                ctx.fillText(siteLine2, canvas.width-text.width, canvas.height/2+15,text.width);
                //ctx.fillStyle = 'green';
                //ctx.fillRect(10, 10, 100, 100);
                // ctx.clearRect(0,0,canvas.width, canvas.height);

                // event info at the bottom
                ctx.imageSmoothingEnabled = true;
                ctx.drawImage(img,50,canvas.height-100,100,100*img.height/img.width);
                ctx.textAlign = 'left';
                ctx.font = '30px sans-serif';
                ctx.fillText(event.name,150,canvas.height-90);
                ctx.font = '20px sans-serif';
                ctx.fillText(event.group.name,150,canvas.height-70);
                ctx.fillText(`@${event.venue.name}`,150,canvas.height-50);
                ctx.fillText(`${eventDateTime.toLocaleDateString(undefined,dateTimeOptions)}, ${eventDateTime.toLocaleTimeString()}`,150,canvas.height-30);
            }

           // scene layout
            if (sceneType !== 'live'){
                ctx.fillStyle = 'black';

                ctx.imageSmoothingEnabled = true;
                ctx.drawImage(img,canvas.width/3-50,canvas.height/2-220,100,100*img.height/img.width);
                ctx.textAlign = 'center';
                ctx.font = '30px sans-serif';
                ctx.fillText(event.name,canvas.width/3,canvas.height/2-130);
                ctx.font = '20px sans-serif';
                ctx.fillText(event.group.name,canvas.width/3,canvas.height/2-110);
                ctx.fillText(`@${event.venue.name}`,canvas.width/3,canvas.height/2-90);
                ctx.fillText(`${eventDateTime.toLocaleDateString(undefined,dateTimeOptions)}, ${eventDateTime.toLocaleTimeString()}`,canvas.width/3,canvas.height/2-70);
                ctx.font = '30px sans-serif';
                ctx.fillText(sceneType,canvas.width/3,canvas.height/2-40);
                ctx.font = '20px sans-serif';
                ctx.fillText('more info: otech.events',canvas.width/3,canvas.height/2-20);
            }

       }, 100);



       canvasPublisher = OT.initPublisher('canvas-publisher', {
           videoSource: canvas.captureStream(1).getVideoTracks()[0],
           width: '100%',
           height: '100%',
           name: `dashboard`
       }, (err) =>{
           if (err) {
               clearInterval(interval);
               alert(err.message);
           }
       });

       canvasPublisher.publishAudio(false);
       canvasPublisher.on('destroyed', () => {
           clearInterval(interval);
       });


       session = OT.initSession(openTokCreds.apiKey, openTokCreds.sessionId);
       console.log('session: ',session);
       session.connect(openTokCreds.token);
       session.on({
           sessionConnected: function (){
                console.log('sessionConnected');
                session.publish(canvasPublisher);
               
           },
           streamCreated: function(event) {
               console.log('event.stream: ',event.stream);
               if (event.stream.name.includes('screenshare')) {
                   session.subscribe(event.stream, 'screen', { 
                       insertMode: 'append',
                       width: '100%',
                       height: '100%'
                    });
               } else {
                   session.subscribe(event.stream, 'subscribers', { 
                       insertMode: 'append',
                       width: '100%',
                       height: '100%'
                    });
               }

               setLayoutClass(event.stream.name, event.stream.streamId)

               switch (event.stream.name) {
                    case 'host-camera':
                        hostConnection = event.stream.connection;
                        console.log("hostConnection: ", hostConnection);
                        gotHostCamera = !gotHostCamera;
                        break;
                    case 'host-screenshare':
                        gotHostScreenshare = !gotHostScreenshare;
                        break;
                    case 'guest-camera':
                        guestConnection = event.stream.connection;
                        console.log("guestConnection: ", guestConnection);
                        gotGuestCamera = !gotGuestCamera;
                        break;
                    case 'guest-screenshare':
                        gotGuestScreenshare = !gotGuestScreenshare;
                        break;
                    default:
                        console.log(`Sorry fam, don't know what ${event.detail.sources.name} is.`);
                }


            //    if (event.stream.videoType === 'camera'){
            //        session.subscribe(event.stream, 'camera-container', { insertMode: 'append' });
            //    }
           },
           streamDestroyed: function(event) {
                console.log("Stream " + event.stream.name + " ended. " + event.reason);
                switch (event.stream.name) {
                    case 'host-camera':
                        gotHostCamera = !gotHostCamera;
                        break;
                    case 'host-screenshare':
                        gotHostScreenshare = !gotHostScreenshare;
                        break;
                    case 'guest-camera':
                        gotGuestCamera = !gotGuestCamera;
                        break;
                    case 'guest-screenshare':
                        gotGuestScreenshare = !gotGuestScreenshare;
                        break;
                    default:
                        console.log(`Sorry fam, don't know what ${event.detail.sources.name} is.`);
                }

            }
       });




    });

    afterUpdate(() => {
        console.log('afterUpdate sceneType: ',sceneType);
        // console.log('afterUpdate: ', mediaContainer.offsetWidth);
        mediaContainerWidth = mediaContainer.offsetWidth;
	});


    async function handleSubmit(e){
        status = "";
        $db.collection('broadcasts').doc(event.id).set({ password:e.target.password.value }, { merge: true })
        .then(function() {
            status = "Password Saved!";
        })
        .catch(function(error) {
            status = `Error saving password: ${error}`;
        });

    }

    async function handleCopy(e){
        copyStatus = "";
        navigator.clipboard.writeText(guestLink)
        .then(function() {
        /* clipboard successfully set */
        copyStatus = "Copied to clipboard."
        }, function(error) {
        /* clipboard write failed */
        copyStatus = "Failed to copy."
        });
    }

    function setScene(line1, line2, type){
        textLine1 = line1;
        textLine2 = line2;
        sceneType = type;
        // update broadcast video layout
    }

    function startBroadcastHandler(){
        console.log('startBroadcastHandler!');
        broadcastStatus = 'Starting...';
        const startBroadcast = $functions.httpsCallable('startBroadcast');
        startBroadcast({sessionId: session.id, name: event.name, eventId: event.id})
            .then(function(result){
                console.log('startBroadcastHandler result: ',result);
                broadcast = result.data.broadcast;
                broadcastStatus = broadcast.status;
                archive = result.data.archive;
                console.log('got the archive!: ', archive);
                // isBroadcasting = true;

                if (broadcast.broadcastUrls) {
                    // Show YouTube confirmation modal
                    // showYouTubeConfirm = true;
                    $db.collection('events').doc(event.id).set({ status:"live", livestream:broadcast.broadcastUrls.hls }, { merge: true })
                    .then(function() {
                        isBroadcasting = true;
                    })
                    .catch(function(error) {
                        console.log('Error saving to database: ', error);
                        broadcastStatus = 'Error - see console';
                    });
                }
            })
            .catch(function(error){
                console.log('Error starting broadcast: ',error);
                broadcastStatus = 'Error - see console';
            });
    }

    // function confirmStartBroadcastHandler(){
    //     console.log('confirmStartBroadcastHandler');
    //     showYouTubeConfirm = true;
    // }

    function confirmYouTube(customEvent) {
        showYouTubeConfirm = false;
        $db.collection('events').doc(event.id).set({ status:"live", livestream:broadcast.broadcastUrls.hls, hasVideo:true, video:[customEvent.detail.text] }, { merge: true })
        .then(function() {
            isBroadcasting = true;
        })
        .catch(function(error) {
            console.log('Error saving to database: ', error);
            broadcastStatus = 'Error - see console';
        });
    }

    function stopBroadcastHandler(){
        console.log('stopBroadcastHandler!');
        showYouTubeConfirm = false;
        broadcastStatus = 'Stopping...';
        const stopBroadcast = $functions.httpsCallable('stopBroadcast');
        stopBroadcast({broadcastId: broadcast.id, archiveId: archive.id})
            .then(function(result){
                console.log('stopBroadcastHandler result: ',result);
                // broadcastStatus = result.data.broadcast.status;

                if (broadcast.broadcastUrls) {
                    $db.collection('events').doc(event.id).set({ status:"past", livestream:'' }, { merge: true })
                        .then(function() {
                            isBroadcasting = false;
                            broadcastStatus = result.data.broadcast.status;

                        })
                        .catch(function(error) {
                            console.log('Error saving to database: ', error);
                            broadcastStatus = 'Error - see console';
                        });
                }




            })
            .catch(function(error){
                console.log('Error stopping broadcast: ',error);
                broadcastStatus = 'Error - see console';
            });
    }

    async function setLayoutClass(name, id){
        console.log('setLayoutClass: ', name, id);
        const setStreamLayoutClass = $functions.httpsCallable('setLayoutClass');
        setStreamLayoutClass({sessionId: openTokCreds.sessionId, id, name})
            .then(function(result){
                console.log('setLayoutClas result: ',result);
            });

        // const data = {
        //     "items": [
        //         {
        //         "id": id,
        //         "layoutClassList": [`${name}`]
        //         }
        //     ]
        // }
        // try {
        //     let response = await fetch(`https://api.opentok.com/v2/project/${openTokCreds.apiKey}/session/${openTokCreds.sessionId}/stream`, {
        //         method: 'PUT',
        //         headers: {
        //             'Content-Type': 'application/json',
        //         },
        //         body: JSON.stringify(data),
        //     })
        //     console.log('response: ',response.json());
        //     if (!response.ok) {
        //         throw new Error('Network response was not ok');
        //     }

        // } catch (error){
        //     console.log('Error with setting layout class: ',error);
        // }
    }

    async function setBroadcastLayout(stylesheet){
        console.log('setBroadcastLayout!');
        const setBroadcastLayout = $functions.httpsCallable('setBroadcastLayout');
        setBroadcastLayout({broadcastId: broadcast.id, archiveId: archive.id, type:'custom', stylesheet})
            .then(function(result){
                console.log('setBroadcastLayout result: ',result);
            });
    }

    async function handleStream(event) {
        console.log('handleStream event: ', event.detail);
        console.log('hostVideo: ', hostVideo);

        // console.log(' session.getPublisherForStream(streamId): ', session.getPublisherForStream(event.detail.sources.streamId));


        // const constraints = { 
        //     audio: { deviceId:event.detail.sources.selectedAudio }, 
        //     video: { 
        //         deviceId:event.detail.sources.selectedVideo,
        //         width: { min: 1024, ideal: 1280, max: 1920 },
        //         height: { min: 576, ideal: 720, max: 1080 },
        //         // facingMode: "user"
        //     }
        // };

        // const constraints = { 
        //     audio: { deviceId:event.detail.sources.selectedAudio }, 
        //     video: {
        //         cursor: "always"
        //     }
        // };

        // videoContainer.style.display = 'block'
        if (event.detail.sources.selectedAudio === null && event.detail.sources.selectedVideo == null){
            if (event.detail.sources.name === 'host-camera'){
                console.log('clear out host video!!!');
                localStream.getTracks().forEach(track => {console.log('track: ', track); track.stop()});

                // hostVideo.pause();
                hostVideo.srcObject = null;
                //hostVideo.removeAttribute('src'); // empty source
                // hostVideo.load();
                console.log('hostVideo src: ', hostVideo.srcObject);

            } else {
                hostScreen.innerHTML = '';

            }
        } else {

            if (event.detail.sources.name === 'host-screenshare'){
                let publisherStreamEvent = session.getPublisherForStream(event.detail.sources.streamId);
                session.subscribe(publisherStreamEvent.stream, 'host-screen', { 
                    insertMode: 'append',
                    width: '100%',
                    height: '100%'
                })

            } else {

                hostConnection = event.detail.sources.connection;
                console.log("hostConnection: ", hostConnection);
                const constraints = { 
                    audio: { deviceId:event.detail.sources.selectedAudio }, 
                    video: { 
                        deviceId:event.detail.sources.selectedVideo,
                        width: { min: 1024, ideal: 1280, max: 1920 },
                        height: { min: 576, ideal: 720, max: 1080 },
                        // facingMode: "user"
                    }
                };

                navigator.mediaDevices.getUserMedia(constraints)
                .then(async function(mediaStream) {
                    localStream = mediaStream;
                    console.log('mediaStream: ', mediaStream);
                    hostVideo.srcObject = mediaStream;
                    hostVideo.onloadedmetadata = function(e) {
                    hostVideo.play();
                    }
                });


            // hostVideo.srcObject = await navigator.mediaDevices.getDisplayMedia(constraints);

            }
            setLayoutClass(event.detail.sources.name, event.detail.sources.streamId)

        };

        switch (event.detail.sources.name) {
            case 'host-camera':
                gotHostCamera = !gotHostCamera;
                break;
            case 'host-screenshare':
                gotHostScreenshare = !gotHostScreenshare;
                break;
            case 'guest-camera':
                gotGuestCamera = !gotGuestCamera;
                break;
            case 'guest-screenshare':
                gotGuestScreenshare = !gotGuestScreenshare;
                break;
            default:
                console.log(`Sorry fam, don't know what ${event.detail.sources.name} is.`);
        }


        // console.log('handleStream event: ',event.detail.stream);
        // if (event.detail.stream.name.includes('screenshare')) {
        //     session.subscribe(event.detail.stream, 'screen', { 
        //         insertMode: 'append',
        //         width: '100%',
        //         height: '100%'
        //     })
        // } else {
        //     session.subscribe(event.detail.stream, 'subscribers', { 
        //         insertMode: 'append',
        //         width: '100%',
        //         height: '100%'
        //      });
        // }

    }

    async function muteConnection (role, connection){
        session.signal(
            {
                to: connection,
                data: "mutePublisher"
            },
            function(error) {
                if (error) {
                    console.log("error muting: ", error);
                } else {
                    console.log("mute signal sent");
                    if (role==='host'){
                        hostMuted = true;
                    } else {
                        guestMuted = true;
                    }                    
                }
            }
        )
    }

    async function unmuteConnection (role, connection){
        session.signal(
            {
                to: connection,
                data: "unmutePublisher"
            },
            function(error) {
                if (error) {
                    console.log("error muting: ", error);
                } else {
                    console.log("mute signal sent");
                    if (role==='host'){
                        hostMuted = false;
                    } else {
                        guestMuted = false;
                    }                    
                }
            }
        )
    }
</script>
<!-- <h1>Livestream dashboard goes here!</h1> -->
<!-- <svelte:window bind:innerWidth={windowWidth}/> -->
<!-- {#if mediaContainer} -->
<!-- mediaContainerWidth: {mediaContainerWidth} -->
<!-- {/if} -->
<!-- changexoffset: {changexoffset} -->
<!-- windowWidth: {windowWidth} -->

<section id="media-container">
    <div id="media">
        <div id="scene-container" class:fullscreen="{showDisplay === 'break'}">
            <Scene {event} {sceneType}/>
        </div>
        <video id="host-video" bind:this={hostVideo} muted class:active="{showDisplay.includes('host')}" class:split="{showDisplay === 'splitCameras'}" class:fullscreen="{showDisplay === 'hostCameraOnly'}"></video>
        <div class="publisher" id="canvas-publisher" bind:this={mediaContainer}></div>
        <div class="subscribers" id="subscribers" class:active="{showDisplay.includes('guest')}" class:split="{showDisplay === 'splitCameras'}" class:fullscreen="{showDisplay === 'guestCameraOnly'}"></div>
        <div class="screen" id="screen" class:active="{showDisplay==='guestCameraAndScreen'}" class:fullscreen="{showDisplay === 'guestScreenOnly'}"></div>
        <div class="screen" id="host-screen" bind:this={hostScreen} class:active="{showDisplay==='hostCameraAndScreen'}" class:fullscreen="{showDisplay === 'hostScreenOnly'}"></div>    
    </div>
    <div id="chat">
        <Chat eventId = {event.id}/>
    </div>

</section>
<div id="controls">
    <section>
        <form id="set-password" on:submit|preventDefault={handleSubmit}>
            <label for="password">Set Password for Guest site</label>
            <input type={showPassword ? "text" : "password"} id="password" required/>&nbsp; &nbsp;<span on:click={() => showPassword = !showPassword}>{showPassword ? "hide" : "show"}</span>
            <br/><button type="submit">submit</button>
        </form>
        <div id="status">{status}</div>

    </section>
    <section>
        Link to share with Guest <br/>
        <input type="text" id="guest-link" value="{guestLink}" disabled />
        <button on:click={handleCopy}>copy to clipboard</button>
        <div id="copy-status">{copyStatus}</div>
    </section>
    <section id="host-media">
        <!-- <Host id={event.id} /> -->
        <Camera id={event.id} {session} {role} on:streamCreated={handleStream} on:streamDestroyed={handleStream}/>
        <Screenshare id={event.id} {session} {role} on:streamCreated={handleStream} on:streamDestroyed={handleStream} />    
    </section>
    <section>
        Controls
        <div id="controls-container">
            <fieldset>
                <legend>Host</legend>
                <button on:click={()=> {
                    showDisplay='hostCameraAndScreen'; 
                    sceneType = 'live';
                    if(isBroadcasting){
                        setBroadcastLayout("broadcast {position: relative; margin:0; width: 1280px; height:720px; overflow: hidden;} stream.dashboard { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 10; } stream.host-camera { position: absolute; width: 20%; height: 20%; bottom: 0px; right: 0px; z-index: 25; } stream.host-screenshare { position: absolute; width: 80%; height: 80%; top: 0px; left: 0px; z-index: 25; } stream.guest-camera { position: absolute; width: 20%; height: 20%; bottom: 0px; right: 0px; z-index: 5; } stream.guest-screenshare { position: absolute; width: 80%; height: 80%; top: 0px; left: 0px; z-index: 5; }")
                    }
                }} disabled={!gotHostCamera || !gotHostScreenshare}>Camera & Screen</button>
                <button on:click={()=> {
                    showDisplay='hostCameraOnly'; 
                    sceneType = 'live';
                    if(isBroadcasting){
                        setBroadcastLayout("broadcast {position: relative; margin:0; width: 1280px; height:720px; overflow: hidden;} stream.dashboard { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 10; } stream.host-camera { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 25; } stream.host-screenshare { position: absolute; width: 80%; height: 80%; top: 0px; left: 0px; z-index: 5; } stream.guest-camera { position: absolute; width: 20%; height: 20%; bottom: 0px; right: 0px; z-index: 5; } stream.guest-screenshare { position: absolute; width: 80%; height: 80%; top: 0px; left: 0px; z-index: 5; }")
                    }

                }} disabled={!gotHostCamera}>Camera Only</button>
                <button on:click={()=> {
                    showDisplay='hostScreenOnly'; 
                    sceneType = 'live';
                    if(isBroadcasting){
                        setBroadcastLayout("broadcast {position: relative; margin:0; width: 1280px; height:720px; overflow: hidden;} stream.dashboard { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 10; } stream.host-camera { position: absolute; width: 20%; height: 20%; bottom: 0px; right: 0px; z-index: 5; } stream.host-screenshare { position: absolute; width: 100%; height: 100%; top: 0px; left: 0px; z-index: 25; } stream.guest-camera { position: absolute; width: 20%; height: 20%; bottom: 0px; right: 0px; z-index: 5; } stream.guest-screenshare { position: absolute; width: 80%; height: 80%; top: 0px; left: 0px; z-index: 5; }")
                    }
                }} disabled={!gotHostScreenshare}>Screen Only</button>

                <button on:click={()=> {
                    showDisplay='splitCameras'; 
                    sceneType = 'live';
                    if(isBroadcasting){
                        setBroadcastLayout("broadcast {position: relative; margin:0; width: 1280px; height:720px; overflow: hidden;} stream.dashboard { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 10; } stream.host-camera { position: absolute; width: 50%; height: 100%; bottom: 0px; left: 0px; z-index: 25} stream.host-screenshare { position: absolute; width: 10%; height: 10%; top: 0px; left: 0px; z-index: 5; } stream.guest-camera { position: absolute; width: 50%; height: 100%; bottom: 0px; right: 0px; z-index: 25; } stream.guest-screenshare { position: absolute; width: 10%; height: 10%; top: 0px; left: 0px; z-index: 5; }")
                    }
                }} disabled={!gotHostCamera || !gotGuestCamera}>Host & Guest Camera</button>

                {#if !hostMuted}
                    <button on:click={()=>{
                        console.log('mute host');
                        muteConnection('host',hostConnection)
                    }} disabled={!gotHostCamera}>Mute Host</button>
                {/if}

                {#if hostMuted}
                    <button on:click={()=>{
                        console.log('unmute host');
                        unmuteConnection('host',hostConnection)
                    }} disabled={!gotHostCamera}>Unmute Host</button>
                {/if}

            </fieldset>
            <fieldset>
                <legend>Guest</legend>
                <button on:click={()=> {
                    showDisplay='guestCameraAndScreen'; 
                    sceneType = 'live';
                    if(isBroadcasting){
                        setBroadcastLayout("broadcast {position: relative; margin:0; width: 1280px; height:720px; overflow: hidden;} stream.dashboard { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 20; } stream.host-camera { position: absolute; width: 20%; height: 20%; bottom: 0px; right: 0px; z-index: 5; } stream.host-screenshare { position: absolute; width: 80%; height: 80%; top: 0px; left: 0px; z-index: 5; } stream.guest-camera { position: absolute; width: 20%; height: 20%; bottom: 0px; right: 0px; z-index: 25; } stream.guest-screenshare { position: absolute; width: 80%; height: 80%; top: 0px; left: 0px; z-index: 25; }")
                    }
                }} disabled={!gotGuestCamera || !gotGuestScreenshare}>Camera & Screen</button>
                <button on:click={()=> {
                    showDisplay='guestCameraOnly'; 
                    sceneType = 'live';
                    if(isBroadcasting){
                        setBroadcastLayout("broadcast {position: relative; margin:0; width: 1280px; height:720px; overflow: hidden;} stream.dashboard { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 10; } stream.host-camera { position: absolute; width: 20%; height: 20%; bottom: 0px; right: 0px; z-index: 5; } stream.host-screenshare { position: absolute; width: 80%; height: 80%; top: 0px; left: 0px; z-index: 5; } stream.guest-camera { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 25; } stream.guest-screenshare { position: absolute; width: 80%; height: 80%; top: 0px; left: 0px; z-index: 5; }")
                    }
                }} disabled={!gotGuestCamera}>Camera Only</button>
                <button on:click={()=> {
                    showDisplay='guestScreenOnly'; 
                    sceneType = 'live';
                    if(isBroadcasting){
                        setBroadcastLayout("broadcast {position: relative; margin:0; width: 1280px; height:720px; overflow: hidden;} stream.dashboard { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 10; } stream.host-camera { position: absolute; width: 20%; height: 20%; bottom: 0px; right: 0px; z-index: 5; } stream.host-screenshare { position: absolute; width: 80%; height: 80%; top: 0px; left: 0px; z-index: 5; } stream.guest-camera { position: absolute; width: 20%; height: 20%; bottom: 0px; right: 0px; z-index: 5; } stream.guest-screenshare { position: absolute; width: 100%; height: 100%; top: 0px; left: 0px; z-index: 25; }")
                    }
                }} disabled={!gotGuestScreenshare}>Screen Only</button>
                {#if !guestMuted}
                    <button on:click={()=>{
                        console.log('mute guest');
                        muteConnection('guest',guestConnection)
                    }} disabled={!gotGuestCamera}>Mute Guest</button>
                {/if}

                {#if guestMuted}
                    <button on:click={()=>{
                        console.log('unmute guest');
                        unmuteConnection('guest',guestConnection)
                    }} disabled={!gotGuestCamera}>Unmute Guest</button>
                {/if}

            </fieldset>
            <fieldset>
                <legend>Scenes</legend>
                <!-- <button on:click={()=> setScene('Starting', 'soon','break')}>Starting soon</button>
                <button on:click={()=> setScene('We will be', 'right back!','break')}>Taking a break</button>
                <button on:click={()=> setScene('Thanks for', 'watching!','break')}>Event finished</button> -->
                <button on:click={()=> {
                    showDisplay='break'; 
                    sceneType = 'Starting Soon.'
                    if(isBroadcasting){
                        setBroadcastLayout("broadcast {position: relative; margin:0; width: 1280px; height:720px; overflow: hidden;} stream.dashboard { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 35; } stream.host-camera { position: absolute; width: 10%; height: 10%; bottom: 0px; right: 0px; z-index: 10; } stream.host-screenshare { position: absolute; width: 10%; height: 10%; top: 0px; left: 0px; z-index: 10; } stream.guest-camera { position: absolute; width: 10%; height: 10%; bottom: 0px; right: 0px; z-index: 10; } stream.guest-screenshare { position: absolute; width: 10%; height: 10%; top: 0px; left: 0px; z-index: 10; }")
                    }
                }}>Starting soon</button>
                <button on:click={()=> {
                    showDisplay='break'; 
                    sceneType = 'Be Right Back!';
                    if(isBroadcasting){
                        setBroadcastLayout("broadcast {position: relative; margin:0; width: 1280px; height:720px; overflow: hidden;} stream.dashboard { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 35; } stream.host-camera { position: absolute; width: 10%; height: 10%; bottom: 0px; right: 0px; z-index: 10; } stream.host-screenshare { position: absolute; width: 10%; height: 10%; top: 0px; left: 0px; z-index: 10; } stream.guest-camera { position: absolute; width: 10%; height: 10%; bottom: 0px; right: 0px; z-index: 10; } stream.guest-screenshare { position: absolute; width: 10%; height: 10%; top: 0px; left: 0px; z-index: 10; }")
                    }
                }}>Taking a break</button>
                <button on:click={()=> {
                    showDisplay='break'; 
                    sceneType = 'See You Next Time!'
                    if(isBroadcasting){
                        setBroadcastLayout("broadcast {position: relative; margin:0; width: 1280px; height:720px; overflow: hidden;} stream.dashboard { position: absolute; width: 100%; height: 100%; bottom: 0px; right: 0px; z-index: 35; } stream.host-camera { position: absolute; width: 10%; height: 10%; bottom: 0px; right: 0px; z-index: 10; } stream.host-screenshare { position: absolute; width: 10%; height: 10%; top: 0px; left: 0px; z-index: 10; } stream.guest-camera { position: absolute; width: 10%; height: 10%; bottom: 0px; right: 0px; z-index: 10; } stream.guest-screenshare { position: absolute; width: 10%; height: 10%; top: 0px; left: 0px; z-index: 10; }")
                    }
                }}>Event finished</button>
            </fieldset>
            <fieldset>
                <legend>Stream</legend>
                {#if !isBroadcasting}
                    <button on:click={startBroadcastHandler}>Start</button>
                {/if}
                {#if isBroadcasting}
                    <button on:click={stopBroadcastHandler}>Stop</button>
                {/if}
                <br/>Status:
                <br/> {broadcastStatus}
            </fieldset>    
        </div>
    </section>
    {#if showYouTubeConfirm}
        <section class="modal">
            <ConfirmYouTube on:confirm={confirmYouTube} on:cancel={stopBroadcastHandler}></ConfirmYouTube>
        </section>
    {/if}
</div>

<style>
    #controls {
        display: flex;
        width: 90vw;
        overflow: auto;
        align-items: center;
    }
    #controls section {
        width: 100%;
        flex: 1 0 90vw;
    }
    #host-media{
        display: flex;
        align-items: center;
        /* height: 25vh; */
    }
    #screen {
        position: absolute;
        left: 0;
        top: 0;
        width: 80%;
        height: 80%;
        z-index: 10;
    }
    #host-screen {
        position: absolute;
        left: 0;
        top: 0;
        width: 80%;
        height: 80%;
        z-index: 10;
    }
    #subscribers {
        position: absolute;
    /*     width: 360px;
        height: 240px; */
        width:20%;
        height:20%;
        bottom: 0px;
        right: 0px;
        z-index: 10;
        border: 3px solid white;
        border-radius: 3px;
    }

    #subscribers.split {
        width: 50%;
        height: 100%;
        z-index: 20 !important;
    }

    #canvas-publisher {
        position: absolute;
        width: 1280px;
        height: 720px;
        top: 0px;
        left: 0px;
        z-index: -5;
    }

    #scene-container {
        position: absolute;
        max-width: 1280px;
        max-height: 720px;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        z-index: 5;
    }

    Scene {
        display:none;
        position: absolute;
        max-width: 1280px;
        max-height: 720px;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        z-index: 5;
    }

    #media-container {
        display: flex;
        width: 97vw;
    }

    #media {
        position: relative;
        width: 100%;
        height: 70vh;
        overflow: hidden;
    }

    #chat {
        width: 30vw;
        height: 60vh;
    }

    .fullscreen {
        width: 100% !important;
        height: 100% !important;
        z-index: 20 !important;
        background-color: white;
    }

    .OT_subscriber{
        width: 100% !important;
        height: 100% !important;
    }

    #controls-container {
        display: flex;
    }

    #host-video {
        position:absolute;
        bottom: 0;
        right: 0;
        z-index: 10;
        width: 20%;
    }

    #host-video.split{
        width: 50% !important;
        height: 100% !important;
        z-index: 20 !important;
        background-color: white;
        left: 0;
    }

    .active {
        z-index: 20 !important;
    }

    .modal {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .55);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
    }
</style>